import axios from "axios";

interface ApiResponse {
  data: any[];
  status: string;
}

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";

const getMemberUser = async (rowId: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/get_member_user/`,
      rowId
    );
    return data;
  } catch (error) {
    return error;
  }
};

const getUserInfo = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/get_member_user_info/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const updateMemberUser = async (rowId: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/update_member_user_info/`,
      rowId
    );
    return data;
  } catch (error) {
    return error;
  }
};

const resetPassword = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/reset_user_password/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const MemberUser = {
  getMemberUser,
  getUserInfo,
  updateMemberUser,
  resetPassword,
};
export default MemberUser;
